import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import {
  CREATE_COUNTRY,
  UPDATE_COUNTRY,
} from "../../../../graphql/mutations/management";
import UploadCountryImage from "./UploadCountryImage";
import { FETCH_COUNTRIES } from "../../../../graphql/queries/management";
import {
  clearCountryForm,
  onChangeCountryForm,
  uploadCountryImage,
} from "../../redux/countrySlice";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const CountryForm = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { createForm, updateForm, isEdit, file, uploadLoading } = useSelector(
    (state) => state.country
  );

  const [createCountry, { loading }] = useMutation(CREATE_COUNTRY, {
    refetchQueries: [{ query: FETCH_COUNTRIES }],
    onCompleted: (data) => {
      if (data) {
        handleClose();
        showSuccessToast();
        dispatch(clearCountryForm());
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const [updateCountry, { loading: updateLoading }] = useMutation(
    UPDATE_COUNTRY,
    {
      refetchQueries: [{ query: FETCH_COUNTRIES }],
      onCompleted: (data) => {
        if (data) {
          handleClose();
          showSuccessToast();
          dispatch(clearCountryForm());
        }
      },
      onError(err) {
        showErrorToast(err.message);
      },
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (file) {
      const { payload } = await dispatch(uploadCountryImage());
      if (payload?.success) {
        isEdit
          ? updateCountry({
              variables: {
                id: updateForm.id,
                input: {
                  name: updateForm.name,
                  imageUrl: payload.url,
                },
              },
            })
          : createCountry({
              variables: {
                input: {
                  name: createForm.name,
                  imageUrl: payload.url,
                },
              },
            });
      } else {
        toast.error(`ບໍສາມາອັບໂຫຼດຮູບໄດ້ ກາລຸນາລອງໃໝ່`, {
          position: "top-center",
          className: "lao",
        });
      }
    } else {
      isEdit
        ? updateCountry({
            variables: {
              id: updateForm.id,
              input: {
                name: updateForm.name,
              },
            },
          })
        : createCountry({
            variables: {
              input: {
                name: createForm.name,
              },
            },
          });
    }
  };

  const handleChange = (e) =>
    dispatch(onChangeCountryForm({ [e.target.name]: e.target.value }));

  const isLoading = isEdit ? updateLoading : loading;

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ຊື່ປະເທດ"
        name="name"
        onChange={handleChange}
        type="text"
        value={isEdit ? updateForm.name : createForm?.name}
        placeholder="ຊື່ປະເທດ"
        errorParam="name"
        required={true}
      />
      <UploadCountryImage />
      <div className="text-center">
        <SubmitButton loading={uploadLoading || isLoading} />
      </div>
    </Form>
  );
};

export default CountryForm;
